import script from "./CommonCatalogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonCatalogModal.vue?vue&type=script&setup=true&lang=js"

import "./CommonCatalogModal.vue?vue&type=style&index=0&id=e0bf8838&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0bf8838"]])

export default __exports__